<template>
  <div class="home-container">
    <!-- 欢迎与核心指标卡片 -->
    <el-card class="welcome-card glass-card" shadow="hover" v-loading="dashboardLoading" element-loading-text="加载中...">
      <template #header>
        <div class="card-header">
          <div class="header-left">
              <el-icon class="card-icon"><House /></el-icon>
              <span>欢迎使用 「爱丽丝小世界」管理系统</span>
            </div>
          <div class="header-right">
            <el-icon class="card-icon"><Cloudy /></el-icon>
            <span v-if="weatherData">
              当前天气: 
              <span v-if="weatherLoading">加载中...</span>
              <span v-else>
                {{ weatherData.weather_description }} {{ weatherData.temperature }}°C
              </span>
            </span>
          </div>
        </div>
      </template>
      <div class="welcome-content">
        <div class="welcome-main">
          <div class="welcome-text-container">
            <h2 class="welcome-title">你好，{{ userInfo?.name }}</h2>
            <p class="welcome-subtitle">今天是 {{ currentDate }}，{{ festivalGreeting }}</p>
          </div>
        </div>
        <div class="core-metrics">
          <el-row :gutter="24">
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-label">今日营收</div>
                <div class="metric-value">¥{{ todayRevenue.toLocaleString() }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-label">今日订单</div>
                <div class="metric-value">{{ todayOrders }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-label">今日退款</div>
                <div class="metric-value">¥{{ todayRefunds.toLocaleString() }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="metric-item">
                <div class="metric-label">活跃用户</div>
                <div class="metric-value">{{ activeUsers }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>

    <!-- 核心业务概览区 -->
    <div class="dashboard-section">
      <h3 class="section-title">
        <el-icon class="section-icon"><DataAnalysis /></el-icon>
        业务概览
      </h3>
      <el-row :gutter="20">
        <!-- 订单管理模块 -->
        <el-col :span="8">
          <el-card class="business-card glass-card" shadow="hover" v-loading="dashboardLoading" element-loading-text="加载中...">
            <template #header>
              <div class="card-header">
                <el-icon class="card-icon"><ShoppingBag /></el-icon>
                <span>商城订单管理</span>
              </div>
            </template>
            <div class="business-content">
              <div class="business-stats">
                <div class="stat-row">
                  <span class="stat-label">订单总数:</span>
                  <span class="stat-value">{{ orderStats.total }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">待处理:</span>
                  <span class="stat-value pending">{{ orderStats.pending }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">已完成:</span>
                  <span class="stat-value success">{{ orderStats.completed }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">已取消:</span>
                  <span class="stat-value cancelled">{{ orderStats.cancelled }}</span>
                </div>
              </div>
              <div class="chart-container small-chart">
                <el-chart height="150px">
                  <el-tooltip :show-content="true" :position="'top'" />
                  <el-axis type="category" position="bottom" />
                  <el-axis type="value" position="left" />
                  <el-line :data="orderTrends" :y-field="'count'" :x-field="'date'" :smooth="true" />
                </el-chart>
              </div>
              <div class="business-actions">
                <el-button type="primary" size="small" @click="handleQuickAction('orders')">
                  <el-icon><View /></el-icon> 查看订单
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
  <!-- 退款记录模块 -->
        <el-col :span="8">
          <el-card class="business-card glass-card" shadow="hover" v-loading="dashboardLoading" element-loading-text="加载中...">
            <template #header>
              <div class="card-header">
                <el-icon class="card-icon"><ArrowLeft /></el-icon>
                <span>商城退款记录</span>
              </div>
            </template>
            <div class="business-content">
              <div class="business-stats">
                <div class="stat-row">
                  <span class="stat-label">退款总数:</span>
                  <span class="stat-value">{{ refundStats.total }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">待处理:</span>
                  <span class="stat-value pending">{{ refundStats.pending }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">已成功:</span>
                  <span class="stat-value success">{{ refundStats.success }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">成功率:</span>
                  <span class="stat-value">{{ refundStats.success_rate }}%</span>
                </div>
              </div>
              <div class="chart-container small-chart">
                <el-chart height="150px">
                  <el-tooltip :show-content="true" :position="'top'" />
                  <el-axis type="category" position="bottom" />
                  <el-axis type="value" position="left" />
                  <el-line :data="refundTrends" :y-field="'amount'" :x-field="'date'" :smooth="true" />
                </el-chart>
              </div>
              <div class="business-actions">
                <el-button type="primary" size="small" @click="handleQuickAction('refunds')">
                  <el-icon><View /></el-icon> 查看退款记录
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
        <!-- 消费记录模块 -->
        <el-col :span="8">
          <el-card class="business-card glass-card" shadow="hover" v-loading="dashboardLoading" element-loading-text="加载中...">
            <template #header>
              <div class="card-header">
                <el-icon class="card-icon"><Money /></el-icon>
                <span>消费记录</span>
              </div>
            </template>
            <div class="business-content">
              <div class="business-stats">
                <div class="stat-row">
                  <span class="stat-label">消费总数:</span>
                  <span class="stat-value">{{ consumptionStats.total }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">今日笔数:</span>
                  <span class="stat-value pending">{{ consumptionStats.today_count }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">今日金额:</span>
                  <span class="stat-value success">¥{{ consumptionStats.today_amount.toLocaleString() }}</span>
                </div>
                <div class="stat-row">
                  <span class="stat-label">平均消费:</span>
                  <span class="stat-value">¥{{ consumptionStats.avg_amount.toLocaleString() }}</span>
                </div>
              </div>
              <div class="chart-container small-chart">
                <el-chart height="150px">
                  <el-tooltip :show-content="true" :position="'top'" />
                  <el-axis type="category" position="bottom" />
                  <el-axis type="value" position="left" />
                  <el-line :data="consumptionTrends" :y-field="'amount'" :x-field="'date'" :smooth="true" />
                </el-chart>
              </div>
              <div class="business-actions">
                <el-button type="primary" size="small" @click="handleQuickAction('consumptions')">
                  <el-icon><View /></el-icon> 查看消费记录
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>

      
      </el-row>
    </div>


    <!-- 待办事项与异常提醒 -->
    <div class="dashboard-section">
      <h3 class="section-title">
        <el-icon class="section-icon"><List /></el-icon>
        待办事项
      </h3>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card class="todo-card glass-card" shadow="hover" v-loading="dashboardLoading" element-loading-text="加载中...">
            <template #header>
              <div class="card-header">
                <el-icon class="card-icon"><List /></el-icon>
                <span>任务清单</span>
              </div>
            </template>
            <div class="todo-content">
              <div class="todo-item-wrapper">
                <div class="todo-item" v-for="item in todoList" :key="item.id">
                  <div class="todo-info">
                    <h4 class="todo-title">{{ item.title }}</h4>
                    <p class="todo-desc">{{ item.desc }}</p>
                  </div>
                  <el-button 
                    type="primary" 
                    size="small" 
                    @click="item.action"
                    class="todo-action-btn"
                  >
                    <el-icon><Operation /></el-icon> {{ item.btnText }}
                  </el-button>
                </div>
              </div>
              <div v-if="todoList.length === 0" class="empty-todo">
                <div class="empty-icon">
                  <el-icon><CircleCheck /></el-icon>
                </div>
                <h3 class="empty-title">暂无待办事项</h3>
                <p class="empty-desc">您的任务清单已完成，继续保持！</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';
import * as authApi from '../api/auth';
import service from '../api/axios';
import { Lunar } from 'lunar-javascript';
import {
  Cloudy,
  House,
  DataAnalysis,
  Money,
  Operation,
  ShoppingBag,
  CircleCheck,
  List,
  View
} from '@element-plus/icons-vue';
// Element Plus 2.12.0 的图表组件需要使用单独的导入方式
// 不需要显式导入，直接在模板中使用小写标签即可

export default {
  name: 'Home',
  components: {
    Cloudy,
    House,
    DataAnalysis,
    Money,
    Operation,
    ShoppingBag,
    CircleCheck,
    List,
    View
  },
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();
    // 使用ref存储用户信息
    const userInfo = ref(authStore.userInfo);
    const currentDate = ref('');
    const festivalGreeting = ref('祝您工作愉快！');
    const dashboardData = ref(null);
    const dashboardLoading = ref(false);
    
    // 监听authStore中的userInfo变化，实时更新本地ref
    watch(
      () => authStore.userInfo,
      (newUserInfo) => {
        userInfo.value = newUserInfo;
      },
      { immediate: true }
    );
    
    // 天气数据
    const weatherLoading = ref(false);
    const weatherData = ref(null);
    
    // 统计数据
    const todayOrders = ref(0);
    const todayRevenue = ref(0);
    const todayRefunds = ref(0);
    const activeUsers = ref(0);
    const pendingTasks = ref(0);
    
    // 订单数据
    const orderStats = ref({ total: 0, pending: 0, completed: 0, cancelled: 0 });
    const orderTrends = ref([]);
    
    // 消费数据
    const consumptionStats = ref({ total: 0, today_count: 0, today_amount: 0, avg_amount: 0 });
    const consumptionTrends = ref([]);
    
    // 退款数据
    const refundStats = ref({ total: 0, pending: 0, success: 0, failed: 0, success_rate: 0 });
    const refundTrends = ref([]);
    
    // 营收趋势
    const revenueTrends = ref([]);
    
    // 待办事项
    const todoList = ref([]);
    
    // Canvas引用
    const revenueChartCanvas = ref(null);
    
    // 绘制营收趋势折线图
    const drawRevenueChart = () => {
      const canvas = revenueChartCanvas.value;
      if (!canvas || revenueTrends.value.length === 0) return;
      
      const ctx = canvas.getContext('2d');
      const width = canvas.offsetWidth;
      const height = canvas.offsetHeight;
      
      // 设置canvas实际尺寸，解决模糊问题
      canvas.width = width * window.devicePixelRatio;
      canvas.height = height * window.devicePixelRatio;
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      
      // 清空画布
      ctx.clearRect(0, 0, width, height);
      
      // 计算数据范围
      const maxAmount = Math.max(...revenueTrends.value.map(item => item.amount));
      const minAmount = Math.min(...revenueTrends.value.map(item => item.amount));
      const range = maxAmount - minAmount;
      
      // 设置边距
      const margin = { top: 20, right: 20, bottom: 40, left: 50 };
      const chartWidth = width - margin.left - margin.right;
      const chartHeight = height - margin.top - margin.bottom;
      
      // 计算坐标转换函数
      const xScale = (index) => margin.left + (index / (revenueTrends.value.length - 1)) * chartWidth;
      const yScale = (amount) => margin.top + chartHeight - ((amount - minAmount) / range) * chartHeight;
      
      // 绘制坐标轴
      ctx.strokeStyle = '#e4e7ed';
      ctx.lineWidth = 1;
      
      // X轴
      ctx.beginPath();
      ctx.moveTo(margin.left, margin.top + chartHeight);
      ctx.lineTo(margin.left + chartWidth, margin.top + chartHeight);
      ctx.stroke();
      
      // Y轴
      ctx.beginPath();
      ctx.moveTo(margin.left, margin.top);
      ctx.lineTo(margin.left, margin.top + chartHeight);
      ctx.stroke();
      
      // 绘制折线
      ctx.strokeStyle = '#667eea';
      ctx.lineWidth = 2;
      ctx.beginPath();
      
      revenueTrends.value.forEach((item, index) => {
        const x = xScale(index);
        const y = yScale(item.amount);
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      
      ctx.stroke();
      
      // 绘制数据点
      ctx.fillStyle = '#667eea';
      revenueTrends.value.forEach((item, index) => {
        const x = xScale(index);
        const y = yScale(item.amount);
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, 2 * Math.PI);
        ctx.fill();
      });
      
      // 绘制日期标签
      ctx.fillStyle = '#606266';
      ctx.font = '12px sans-serif';
      ctx.textAlign = 'center';
      revenueTrends.value.forEach((item, index) => {
        const x = xScale(index);
        const y = margin.top + chartHeight + 20;
        ctx.fillText(item.date, x, y);
      });
      
      // 绘制金额标签
      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      const yLabels = 5;
      for (let i = 0; i <= yLabels; i++) {
        const y = margin.top + (i / yLabels) * chartHeight;
        const amount = maxAmount - (i / yLabels) * range;
        ctx.fillText(`¥${amount.toFixed(0)}`, margin.left - 10, y);
      }
    };
    
    // 监听revenueTrends变化，重新绘制图表
    watch(revenueTrends, () => {
      nextTick(() => {
        drawRevenueChart();
      });
    }, { deep: true });
    
    // 监听窗口大小变化，重新绘制图表
    onMounted(() => {
      window.addEventListener('resize', drawRevenueChart);
    });
    
    onUnmounted(() => {
      window.removeEventListener('resize', drawRevenueChart);
    });

    // 节日祝福语映射
    const getFestivalGreeting = (date) => {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      
      // 转换为农历
      const lunar = Lunar.fromDate(date);
      const lunarMonth = lunar.getMonth();
      const lunarDay = lunar.getDay();
      
      // 阳历节日
      const solarFestivals = [
        { month: 1, day: 1, greeting: '元旦快乐！' },
        { month: 5, day: 1, greeting: '劳动节快乐！' },
        { month: 10, day: 1, greeting: '国庆节快乐！' },
      ];
      
      // 查找阳历节日
      const solarFestival = solarFestivals.find(f => f.month === month && f.day === day);
      if (solarFestival) {
        return solarFestival.greeting;
      }
      
      // 农历节日
      // 春节（农历正月初一）
      if (lunarMonth === 1 && lunarDay === 1) {
        return '春节快乐！';
      }
      
      // 除夕（农历十二月最后一天）
      // 通过检查第二天是否是正月初一来判断
      const nextDay = new Date(date.getTime() + 24 * 60 * 60 * 1000);
      const nextLunar = Lunar.fromDate(nextDay);
      if (lunarMonth === 12 && nextLunar.getMonth() === 1 && nextLunar.getDay() === 1) {
        return '除夕快乐！';
      }
      
      // 端午节（农历五月初五）
      if (lunarMonth === 5 && lunarDay === 5) {
        return '端午节快乐！';
      }
      
      // 中秋节（农历八月十五）
      if (lunarMonth === 8 && lunarDay === 15) {
        return '中秋节快乐！';
      }
      
      // 普通工作日
      return '祝您工作愉快！';
    };

    // 更新时间
    const updateTime = () => {
      const now = new Date();
      // 格式化日期
      currentDate.value = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      });
      
      // 获取节日祝福语
      festivalGreeting.value = getFestivalGreeting(now);
    };

    // 获取首页数据
    const fetchDashboardData = async () => {
      dashboardLoading.value = true;
      try {
        const response = await authApi.getDashboardData();
        if (response.code === 200 && response.data) {
          dashboardData.value = response.data;
          
          // 更新统计数据，确保为数字类型
          todayOrders.value = parseInt(response.data.today_orders || 0);
          todayRevenue.value = parseFloat(response.data.today_revenue || 0);
          todayRefunds.value = parseFloat(response.data.today_refunds || 0);
          activeUsers.value = parseInt(response.data.active_users || 0);
          pendingTasks.value = parseInt(response.data.pending_tasks?.total || 0);
          
          // 更新订单数据，确保金额为数字类型
          orderStats.value = response.data.order_stats || { total: 0, pending: 0, completed: 0, cancelled: 0 };
          orderTrends.value = (response.data.order_trends || []).map(item => ({
            ...item,
            amount: parseFloat(item.amount || 0)
          }));
          
          // 更新消费数据，确保金额为数字类型
          consumptionStats.value = response.data.consumption_stats || { total: 0, today_count: 0, today_amount: 0, avg_amount: 0 };
          consumptionTrends.value = (response.data.consumption_trends || []).map(item => ({
            ...item,
            amount: parseFloat(item.amount || 0)
          }));
          
          // 更新退款数据，确保金额为数字类型
          refundStats.value = response.data.refund_stats || { total: 0, pending: 0, success: 0, failed: 0, success_rate: 0 };
          refundTrends.value = (response.data.refund_trends || []).map(item => ({
            ...item,
            amount: parseFloat(item.amount || 0)
          }));
          
          // 生成营收趋势数据（合并订单和消费）
          // 1. 先创建所有7天的日期数组，确保包含所有日期
          const last7Days = [];
          for (let i = 6; i >= 0; i--) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            last7Days.push(date.toISOString().split('T')[0]);
          }
          
          // 2. 创建消费金额映射，确保金额为数字类型
          const consumptionMap = new Map();
          (response.data.consumption_trends || []).forEach(item => {
            consumptionMap.set(item.date, parseFloat(item.amount || 0));
          });
          
          // 3. 创建订单金额映射，确保金额为数字类型
          const orderMap = new Map();
          (response.data.order_trends || []).forEach(item => {
            orderMap.set(item.date, parseFloat(item.amount || 0));
          });
          
          // 4. 生成完整的营收趋势数据，按日期顺序排列
          revenueTrends.value = last7Days.map(date => {
            const consumptionAmount = consumptionMap.get(date) || 0;
            const orderAmount = orderMap.get(date) || 0;
            const totalAmount = consumptionAmount + orderAmount;
            return {
              date: date,
              amount: totalAmount
            };
          });
          
          // 检查数据是否正确生成
          console.log('Generated revenueTrends:', revenueTrends.value);
          console.log('Revenue trends data type check:', {
            firstItemAmount: revenueTrends.value[0]?.amount,
            firstItemAmountType: typeof revenueTrends.value[0]?.amount,
            hasData: revenueTrends.value.some(item => item.amount > 0)
          });
          
          // 生成待办事项列表
          todoList.value = [];
          if (response.data.pending_tasks?.pending_orders > 0) {
            todoList.value.push({
              id: 'pending_orders',
              title: '待处理订单',
              desc: `有 ${response.data.pending_tasks.pending_orders} 个订单需要处理`,
              btnText: '处理订单',
              action: () => handleQuickAction('orders')
            });
          }
          if (response.data.pending_tasks?.pending_refunds > 0) {
            todoList.value.push({
              id: 'pending_refunds',
              title: '待处理退款',
              desc: `有 ${response.data.pending_tasks.pending_refunds} 个退款需要处理`,
              btnText: '处理退款',
              action: () => handleQuickAction('refunds')
            });
          }
          
          // 数据加载完成后绘制图表
          nextTick(() => {
            drawRevenueChart();
          });
        }
      } catch (error) {
        console.error('获取首页数据失败:', error);
      } finally {
        dashboardLoading.value = false;
      }
    };

    // 处理快捷操作
    const handleQuickAction = (type) => {
      switch (type) {
        case 'room':
          router.push('/rooms/list');
          break;
        case 'booking':
          router.push('/bookings/list');
          break;
        case 'user':
          router.push('/users/list');
          break;
        case 'consumption':
        case 'consumptions':
          router.push('/consumptions/list');
          break;
        case 'orders':
          router.push('/orders/list');
          break;
        case 'refunds':
          router.push('/refunds/list');
          break;
        case 'products':
          router.push('/products/list');
          break;
        default:
          break;
      }
    };

    // 获取天气数据
    const fetchWeatherData = async () => {
      weatherLoading.value = true;
      try {
        // 这里假设API端点为/weather，实际应根据后端提供的API调整
        const response = await service({
          method: 'get',
          url: '/weather'
        });
        if (response.code === 200) {
          weatherData.value = response.data;
        }
      } catch (error) {
        // 静默处理天气数据获取失败
      } finally {
        weatherLoading.value = false;
      }
    };

    onMounted(() => {
      // 初始更新时间
      updateTime();
      // 每秒更新一次时间
      setInterval(updateTime, 1000);
      
      // 获取用户信息，确保页面刷新后也能显示欢迎信息
      if (authStore.isLoggedIn && !userInfo.value) {
        authStore.getCurrentUser().catch(error => {
          console.error('获取用户信息失败:', error);
        });
      }
      
      // 获取首页数据
      fetchDashboardData();
      // 每分钟刷新一次首页数据
      setInterval(fetchDashboardData, 60000);
      // 获取天气数据
      fetchWeatherData();
      // 每10分钟刷新一次天气数据
      setInterval(fetchWeatherData, 600000);
    });

    return {
      userInfo,
      currentDate,
      festivalGreeting,
      handleQuickAction,
      todayOrders,
      todayRevenue,
      todayRefunds,
      activeUsers,
      pendingTasks,
      dashboardLoading,
      
      // 天气数据
      weatherLoading,
      weatherData,
      
      // 订单数据
      orderStats,
      orderTrends,
      
      // 消费数据
      consumptionStats,
      consumptionTrends,
      
      // 退款数据
      refundStats,
      refundTrends,
      
      // 营收趋势
      revenueTrends,
      
      // 待办事项
      todoList,
      
      // Canvas引用
      revenueChartCanvas
    };
  },
};
</script>

<style scoped>
/* 浅色背景 with subtle background image */
.home-container {
  padding: 20px;
  background: #ffffff;
  color: #2c3e50;
  min-height: calc(100vh - 60px);
  position: relative;
  overflow: hidden;
}

.home-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.1;
  z-index: 0;
}



/* 卡片效果 */
.glass-card {
  background: #ffffff !important;
  border: 1px solid #e4e7ed !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
  color: #2c3e50 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  z-index: 1 !important;
  overflow: hidden !important;
}

.glass-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px 16px 0 0;
  z-index: 2;
}

.glass-card:hover {
  box-shadow: 0 8px 28px rgba(102, 126, 234, 0.15) !important;
  transform: translateY(-2px) !important;
  border-color: #667eea33 !important;
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%) !important;
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.card-icon {
  font-size: 24px;
  color: #667eea;
  margin-right: 12px;
}

/* 欢迎卡片 */
.welcome-card {
  margin-bottom: 24px;
}

.welcome-content {
  padding: 30px 20px;
}

.welcome-main {
  display: flex;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

/* .welcome-avatar removed */

.welcome-text-container {
  flex: 1;
  min-width: 200px;
}

.welcome-title {
  margin: 0 0 8px 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-subtitle {
  margin: 0 0 16px 0;
  color: #606266;
  font-size: 16px;
}

.user-role-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.admin-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.employee-badge {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.system-stats {
  margin-top: 24px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 12px;
  border: 1px solid #e4e7ed;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

/* 数据统计区域 */
.dashboard-section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #2c3e50;
  position: relative;
  z-index: 1;
}

.section-icon {
  font-size: 24px;
  margin-right: 12px;
  color: #667eea;
}

/* 统计卡片 */
.stat-card {
  height: 200px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  margin-bottom: 20px;
}

.stat-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.stat-icon {
  font-size: 28px;
  margin-right: 12px;
  border-radius: 8px;
  padding: 8px;
}

.room-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.occupancy-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.booking-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
}

.revenue-icon {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  color: white;
}

.stat-title {
  font-size: 16px;
  color: #606266;
  font-weight: 500;
}

.stat-value {
  font-size: 48px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 12px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: -1px;
}

.stat-desc {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #606266;
}

.trend-icon {
  margin-right: 8px;
  color: #43e97b;
}

/* 仪表盘网格布局 */
.dashboard-grid {
  display: flex;
  gap: 20px;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}

/* 确保所有主要内容区域都在背景图之上 */
.welcome-card,
.dashboard-section,
.core-metrics {
  position: relative;
  z-index: 1;
}

/* 图表卡片 */
.chart-card {
  height: 300px;
  display: flex;
  flex-direction: column;
}

.chart-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.chart-skeleton {
  width: 100%;
  max-width: 500px;
}

.skeleton-line {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}

@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.chart-loading-text {
  color: #909399;
  font-size: 16px;
}

/* 快捷操作卡片 */
.quick-actions-card {
  height: 300px;
  display: flex;
  flex-direction: column;
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  flex: 1;
  padding: 10px 0;
}

.quick-action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.quick-action-item:hover {
  background: #ecf5ff;
  border-color: #d9ecff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.quick-action-icon {
  font-size: 32px;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.room-action {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.booking-action {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.user-action {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.consumption-action {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.quick-action-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

/* 监控卡片 */
.monitor-card {
  height: auto;
  margin-bottom: 20px;
}

.guests-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  padding: 16px 0;
}

.guest-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.guest-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.guest-name {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
}

.guest-room {
  font-size: 12px;
  color: #909399;
}

.alerts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.alert-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  background: #fef0f0;
  border: 1px solid #fbc4ab;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.alert-item:hover {
  background: #fde2e2;
  border-color: #f9a826;
}

.alert-icon {
  font-size: 20px;
  padding: 8px;
  border-radius: 50%;
}

.alert-icon.warning {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 4px;
}

.alert-time {
        font-size: 12px;
        color: #909399;
      }

/* 待办事项优化样式 */
.todo-content {
  padding: 20px 0;
}

.todo-item-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.todo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.todo-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
  background: #ffffff;
}

.todo-info {
  flex: 1;
  margin-right: 20px;
}

.todo-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

.todo-desc {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

.todo-action-btn {
  height: 36px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.todo-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

/* 空状态样式 */
.empty-todo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  margin-top: 20px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
}

.empty-icon .el-icon {
  font-size: 40px;
  color: white;
}

.empty-title {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.empty-desc {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  max-width: 300px;
  line-height: 1.5;
}

/* 调试数据样式 */
.debug-data {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  font-family: 'Courier New', Courier, monospace;
}

.debug-data h4 {
  margin-top: 0;
  margin-bottom: 12px;
  color: #667eea;
  font-size: 16px;
  font-weight: 600;
}

.debug-data pre {
  margin: 0;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.5;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .welcome-main {
    flex-direction: column;
    text-align: center;
  }
  
  .dashboard-grid {
    flex-direction: column;
  }
  
  .top-status-bar {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 12px;
  }
  
  .quick-actions-grid {
    grid-template-columns: 1fr;
  }
  
  .guests-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
